import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    list: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_LIST' (state) {
        state.list = [];
    },
    'SET_LIST' (state, params) {
        state.list = params.list;
    },
};

const getters = {
    getField,

    list(state) {
        return state.list;
    },
};

const actions = {
    getList: ({ commit }) => {
        return new Promise((resolve, reject) => {
            let list = ['', 'M', 'F', 'X'];

            let params = {
                list,
            }
            commit('SET_LIST', params);
            resolve();
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}